/*
 * This exists for the sole purpose of testing
 * To override the "current" date in tests, do something like below
 * ex) jest.spyOn(global.Date, 'now').mockImplementation(() => new Date('2020-01-15T11:01:58.135Z').valueOf());
 */
function getCurrentDate() {
	return new Date(Date.now());
}

export const SpecialDateValues = {
	Today: 't',
	PreviousBusinessDay: 'p',
	NextBusinessDay: 'n'
};

const Weekday = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
};

function validateDaysInMonth(month, day, year) {
	switch (month) {
		// February
		case 2:
			return (day > 0 && day < 29) || (day === 29 && year % 4 === 0);
		// January, March, May, July, August, October, December
		case 1:
		case 3:
		case 5:
		case 7:
		case 8:
		case 10:
		case 12:
			return day > 0 && day <= 31;
		// April, June, September, November
		case 4:
		case 6:
		case 9:
		case 11:
			return day > 0 && day <= 30;
		default:
			return false;
	}
}

function getPreviousBusinessDay() {
	const date = getCurrentDate();
	date.setDate(date.getDate() - 1);
	if (date.getDay() === Weekday.Sunday) {
		date.setDate(date.getDate() - 2);
	} else if (date.getDay() === Weekday.Saturday) {
		date.setDate(date.getDate() - 1);
	}
	return date;
}

function getNextBusinessDay() {
	const date = getCurrentDate();
	date.setDate(date.getDate() + 1);
	if (date.getDay() === Weekday.Sunday) {
		date.setDate(date.getDate() + 1);
	} else if (date.getDay() === Weekday.Saturday) {
		date.setDate(date.getDate() + 2);
	}
	return date;
}

function getFourDigitYear(year) {
	let yearString = String(year);
	if (yearString.length < 4) {
		const currentYearString = getCurrentDate().getFullYear().toString();
		let century = currentYearString.substring(0, 2) - 1;
		if (yearString < currentYearString.substring(2, 4) - -10) {
			century = currentYearString.substring(0, 2);
		}
		yearString = century + yearString;
	}
	return yearString;
}

export function formatDate(value, options = { year: 'numeric', month: '2-digit', day: '2-digit' }) {
	let date;
	if (value instanceof Date) {
		date = value;
	} else {
		let stringValue = String(value).replace(/\//g, '').toLowerCase();
		switch (stringValue) {
			case SpecialDateValues.Today:
				date = getCurrentDate();
				break;
			case SpecialDateValues.PreviousBusinessDay:
				date = getPreviousBusinessDay();
				break;
			case SpecialDateValues.NextBusinessDay:
				date = getNextBusinessDay();
				break;
			default: {
				if (/^\d+$/.test(stringValue)) {
					if (typeof value === 'number' && (stringValue.length === 5 || stringValue.length === 7)) {
						// zero pad stringValue.  Assume one digit month was provided
						stringValue = `0${stringValue}`;
					}

					let tmpDate;
					if (stringValue.length > 8) {
						tmpDate = new Date(Number(stringValue));
					} else {
						const currentYear = getCurrentDate().getFullYear();
						let month, day, year;
						if (
							stringValue.length === 8 &&
							stringValue.substring(0, 4) - 0 > currentYear - 100 &&
							stringValue.substring(0, 4) - 0 < currentYear - -10
						) {
							// yyyyMMdd format
							month = Number(stringValue.substring(4, 6));
							day = Number(stringValue.substring(6, 8));
							year = Number(stringValue.substring(0, 4));
						} else {
							// `MMddyyyy or MMddyy format
							month = Number(stringValue.substring(0, 2));
							day = Number(stringValue.substring(2, 4));
							year = Number(getFourDigitYear(stringValue.substring(4, stringValue.length)));
						}

						if (validateDaysInMonth(month, day, year)) {
							tmpDate = new Date(year, month - 1, day, 0, 0, 0, 0);
						}
					}
					if (tmpDate?.getTime() > 0) {
						date = tmpDate;
					}
				}
			}
		}
	}

	if (date) {
		if (typeof options === 'string') {
			const dateParts = new Intl.DateTimeFormat('en-US', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				fractionalSecondDigits: 3,
				hour12: false
			})
				.formatToParts(date)
				.filter(part => part.type !== 'literal')
				.reduce((accumulator, part) => {
					if (part.type === 'year' && options.indexOf('yyyy') === -1) {
						part.value = part.value.substring(2, 4);
					} else if (part.type === 'fractionalSecond' && options.indexOf('SSS') === -1) {
						part.value = part.value.substring(0, 2);
					}
					accumulator[part.type] = part.value;
					return accumulator;
				}, {});

			return options
				.replace(/dd/g, dateParts.day)
				.replace(/MM/g, dateParts.month)
				.replace(/y{1,4}/g, dateParts.year)
				.replace(/hh/g, dateParts.hour)
				.replace(/mm/g, dateParts.minute)
				.replace(/ss/g, dateParts.second)
				.replace(/f{1,3}/g, dateParts.fractionalSecond);
		} else {
			return new Intl.DateTimeFormat('en-US', options).format(date);
		}
	}

	return value;
}
